<template>
  <section class="world-panel">
    <div class="head">
      <div>
        <h3>游戏世界感知</h3>
        <p class="hint">信息来自 SMAPI 游戏端实际采集，每 15 秒更新一次；未接入或已过期的数据不会当作事实。</p>
      </div>
      <el-button size="small" :loading="busy" @click="refresh">刷新</el-button>
    </div>
    <div v-if="world?.available && world?.worldReady" class="world-live">
      <el-tag type="success" effect="plain">SMAPI 实时状态已连接</el-tag>
      <div class="facts">
        <div><span>游戏日期</span><strong>{{world.year||'—'}} 年 · {{seasons[world.season]||'—'}} · {{world.day||'—'}} 日</strong></div>
        <div><span>游戏时间</span><strong>{{clock(world.timeOfDay)}}</strong></div>
        <div><span>天气</span><strong>{{world.isSnowing?'下雪':world.isRaining?'下雨':'无雨雪'}}</strong></div>
        <div><span>主机角色所在场景</span><strong>{{world.hostLocation||'未取得'}}</strong></div>
      </div>
      <p class="hint">采集时间：{{formatTime(world.observedAtUtc)}}。上报的在线角色：{{world.onlinePlayers?.length??'尚未获取'}}。主机角色不等于 AI 伙伴。</p>
    </div>
    <div v-else class="offline">
      <el-tag effect="plain" type="warning">游戏感知未就绪</el-tag>
      <p>{{world?.message||'正在获取游戏环境状态…'}}</p>
      <p class="hint">游戏可以正常联机；这里只表示还没有有效的 SMAPI 世界状态。AI 不会猜测天气、位置或背包内容。</p>
    </div>
    <div class="companion-presence">
      <template v-if="world?.available && world?.worldReady && world?.aiEntityPresent">
        <el-tag type="success">AI 伙伴实体已在游戏世界中生成</el-tag>
        <p>位置：农场（{{ world.aiTileX }}, {{ world.aiTileY }}） · 状态：{{ world.aiMotion==='walking'?'正在走动':'站立' }}</p>
        <div v-if="Number.isInteger(world.aiWateredToday)" class="work-proof">
          <strong>今日实际浇水：{{ world.aiWateredToday }} 格</strong>
          <span v-if="world.aiWateredToday > 0 && Number.isFinite(world.aiLastWateredTileX) && Number.isFinite(world.aiLastWateredTileY)">
            最近浇水地块：({{ world.aiLastWateredTileX }}, {{ world.aiLastWateredTileY }})
          </span>
          <p class="hint">只统计 SMAPI 确认的作物状态变化；不会把待办计划算作完成。当前计数随游戏主机重新加载而重置。</p>
        </div>
        <p class="hint">人物仍使用游戏内置临时贴图。目前仅支持服务器主动开启的附近作物浇水，收获、背包及其他农活尚未接入。</p>
      </template>
      <template v-else>
        <el-tag type="warning" effect="plain">AI 伙伴实体暂不可见</el-tag>
        <p class="hint">未取得可信游戏实体回执，不能宣称 AI 已在地图中出现。游戏环境感知和聊天可以独立使用。</p>
      </template>
    </div>
  </section>
</template>
<script setup>
import {onMounted,onUnmounted,ref} from 'vue'
import {http} from '../plugins/axios'
const world=ref(null),busy=ref(false)
const seasons={spring:'春',summer:'夏',fall:'秋',winter:'冬'}
let timer
function clock(value){
 if(!Number.isInteger(value))return '—'
 return String(Math.floor(value/100)).padStart(2,'0')+':'+String(value%100).padStart(2,'0')
}
function formatTime(value){
 if(!value)return '未知'
 const time=new Date(value)
 return Number.isNaN(time.getTime())?'未知':time.toLocaleTimeString('zh-CN',{hour12:false})
}
async function refresh(){
 if(busy.value)return
 busy.value=true
 try{
   const {data}=await http.get('/api/manage/ai/world',{params:{_t:Date.now()},timeout:12000})
   world.value=data
 }catch(e){
   world.value={available:false,message:'读取失败，可点击刷新重试'}
 }finally{busy.value=false}
}
onMounted(()=>{
 refresh()
 timer=setInterval(()=>{if(!document.hidden)refresh()},15000)
})
onUnmounted(()=>clearInterval(timer))
</script>
<style scoped>
.world-panel{padding:24px;border:1px solid #dce9db;border-radius:14px;background:#fcfefb;margin:0 0 20px}
.head{display:flex;align-items:flex-start;justify-content:space-between;gap:12px}
h3{font-size:17px;margin:0;color:#35583f}
.hint{font-size:12px;color:#778b7a;line-height:1.8;margin:5px 0 12px}
.world-live,.offline{padding:16px;border-radius:10px;background:#f2f8f0;margin-top:10px}
.facts{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:15px;margin-top:15px}
.facts span{display:block;font-size:12px;color:#7c947e;margin-bottom:5px}
.facts strong{color:#375b41;font-size:14px}
.offline p{color:#637767;font-size:13px;line-height:1.7}
.companion-presence{border-top:1px solid #e2eee0;margin-top:16px;padding-top:14px;color:#426447;font-size:13px}
.companion-presence p{line-height:1.75;margin:8px 0 0}
.work-proof{display:flex;flex-direction:column;align-items:flex-start;gap:5px;padding:13px 15px;border:1px solid #dfeadd;border-radius:10px;background:#f4f9f1;margin:12px 0;color:#3f6449}
.work-proof strong{font-size:14px}.work-proof span{font-size:12px}
.work-proof .hint{margin:2px 0 0}
@media(max-width:560px){.world-panel{padding:16px}.facts{grid-template-columns:1fr}}
</style>
